import createReactClass from 'create-react-class';
import React from 'react';

export default createReactClass({
  displayName: 'sliding-panel',

  getDefaultProps() {
    return {
      showBackground: false,
      open: false,
      left: false
    };
  },

  hide() {
    return this.props.onRequestHide != null ? this.props.onRequestHide.call() : undefined;
  },

  render() {
    let { left } = this.props;
    const panelWidth = this.props.width;
    const offscreenWidth =
      typeof panelWidth === 'number'
        ? -panelWidth
        : typeof panelWidth === 'string' && panelWidth.endsWith('px')
          ? `-${panelWidth}`
          : `-${String(panelWidth)}`;

    const backgroundStyle = {
      width: '100%',
      height: '100%',
      background: 'black',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 101,
      opacity: 0,
      pointerEvents: 'none',
      transition: 'opacity .2s ease-out'
    };

    const defaultStyle = {
      display: 'flex',
      flexFlow: 'column nowrap',
      position: 'fixed',
      height: '100%',
      width: this.props.width,
      background: 'white',
      overflow: 'visible',
      overflowX: 'visible',
      transition: (left ? 'left' : 'right') + ' .2s ease-out, box-shadow .2s ease-out',
      zIndex: 101
    };

    if (this.props.open) {
      defaultStyle[left ? 'left' : 'right'] = 0;
      defaultStyle.boxShadow = '-4px 6px 12px 0px rgba(0,0,0,0.3)';
      backgroundStyle.pointerEvents = 'auto';
      if (this.props.showBackground) {
        backgroundStyle.opacity = 0.5;
      }
    } else {
      defaultStyle[left ? 'left' : 'right'] = offscreenWidth;
      defaultStyle.boxShadow = 'none';
      backgroundStyle.pointerEvents = 'none';
      if (this.props.showBackground) {
        backgroundStyle.opacity = 0;
      }
    }

    return (
      <div>
        {!this.props.allowBackgroundClickthrough ? (
          <div
            onClick={this.hide}
            style={Object.assign({}, backgroundStyle, this.props.backgroundStyle)}
          />
        ) : (
          ''
        )}
        <div style={Object.assign({}, defaultStyle, this.props.style)}>{this.props.children}</div>
      </div>
    );
  }
});
